export default __webpack_public_path__ + "static/media/Icon Campaign Setting.6ae9e643.svg";